"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DebugOffer = void 0;
var _mui = require("@ori-ui/mui");
var _contexts = require("../../../../contexts");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render debug info for offer.
 */
const DebugOffer = () => {
  const {
    offer: {
      choiceId,
      maxAmountToSpend,
      maxQuantityToBuy,
      maxQuantityToBuyPerItem
    },
    remainingAmount
  } = (0, _contexts.useOfferDetail)();
  const {
    showDebugInfo
  } = (0, _contexts.useCheckoutOffers)();
  if (!showDebugInfo) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["offerId: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: String(choiceId)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["maxAmountToSpend: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: String(maxAmountToSpend)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["remainingAmount: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: String(remainingAmount)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["maxQuantityToBuy: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: String(maxQuantityToBuy)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["maxQuantityToBuyPerItem: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: String(maxQuantityToBuyPerItem)
      })]
    })]
  });
};
exports.DebugOffer = DebugOffer;